import React from 'react'
import PropTypes from 'prop-types'
import ConfigProductItemTitle from '../ConfigProductItemTitle/ConfigProductItemTitle'
import dangerIcon from '../../../assets/vectors/Icon_Information.svg'

const ApplicationQuantity = ({ applications, maxApplications }) => {

  return (
    <>
      <div
        className="config-product-page__item__header"
        style={{ justifyContent: 'space-between'}}
      >
        {maxApplications && maxApplications > 0 ? (
          <ConfigProductItemTitle
            name="Aplicações"
            description={`Máximo de ${maxApplications} ${maxApplications > 1 ? 'aplicações' : 'aplicação'}`}
          />
        ) : (
          <>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <h1 className="config-product-item-title--name">Aplicações</h1>
              <div
                style={{
                  display: 'flex',
                  width: '100%',
                  gap: '16px',
                  flexDirection: 'row!important',
                  alignItems: 'center',
                  height: 20,
                }}
              >
                <img
                  width={16}
                  height={16}
                  src={dangerIcon}
                  alt="Informação de limite de aplicações"
                />
                <p>Este produto não possui limite máximo de aplicações.</p>
              </div>
            </div>
          </>
        )}
        <div style={{ width: '50%', textAlign: 'right', marginTop: 10 }}>
          <h1 className="config-product-page__item__quantity">{`${applications} aplicações realizadas`}</h1>
        </div>
      </div>

      {maxApplications && maxApplications > 0 && applications >= maxApplications ? (
        <div
          style={{
            display: 'flex',
            width: '100%',
            gap: '16px',
            flexDirection: 'row!important',
            alignItems: 'center',
            height: 20,
            marginTop: 5
          }}
        >
          <img width={16} height={16} src={dangerIcon} alt="Informação de limite de aplicações" />
          <p>Limite de aplicações atingido para essa safra.</p>
        </div>
      ) : null}
    </>
  )
}

ApplicationQuantity.propTypes = {
  applications: PropTypes.number.isRequired,
  maxApplications: PropTypes.number.isRequired,
}
export default ApplicationQuantity
